import throttle from "./throttle";

var WyPt;
{
    var instances = [];
    var currentScrollPos = window.scrollY;
    var previousScrollPos = 0;
    var currentScrollDirection = "down";
    var previousScrollDirection = "down";

    WyPt = class {
        constructor(_options) {
            const defaults = {
                element: null,
                offset: {
                    top: "top-top",
                    bottom: "bottom-bottom",
                },
                callback: {
                    enter: function (_el, _dir) {},
                    leave: function (_el, _dir) {},
                },
                pointMode: false,
                debug: false,
            };
            const options = Object.assign({}, defaults, _options);

            this.element = options.element;
            this.offset = options.offset;
            this.callback = options.callback;
            this.pointMode = options.pointMode;
            this.debug = options.debug;

            this.triggerPointTop;
            this.hasPassedFromTop = false;
            this.triggerPointBottom;
            this.hasPassedFromBottom = false;
            this.triggerPointEvent;

            this.animationScheduled = false;

            instances.push(this);

            this.init();

            return this;
        }

        init() {
            var elementOffset = this.getOffset(this.element);
            var elementHeight = this.element.clientHeight;
            var windowHeight = window.innerHeight;

            switch (this.offset.top) {
                case "top-bottom": // Top of element crosses bottom of viewport
                    this.offset.top = -windowHeight;
                    break;
                case "top-middle": // Top of element crosses middle of viewport
                    this.offset.top = -windowHeight / 2;
                    break;
                case "top-top": // Top of element crosses top of viewport
                    this.offset.top = 0;
                    break;
                default:
                    this.offset.top = this.offset.top;
            }

            switch (this.offset.bottom) {
                case "bottom-bottom": // Bottom of element crosses bottom of viewport
                    this.offset.bottom = -windowHeight;
                    break;
                case "bottom-middle": // Bottom of element crosses middle of viewport
                    this.offset.bottom = -windowHeight / 2;
                    break;
                case "bottom-top": // Bottom of element crosses top of viewport
                    this.offset.bottom = 0;
                    break;
                default:
                    this.offset.bottom = this.offset.bottom;
            }

            this.triggerPointTop = elementOffset + this.offset.top;
            this.triggerPointBottom = !this.pointMode
                ? elementOffset + elementHeight + this.offset.bottom
                : this.triggerPointTop;

            if (this.debug) {
                console.log(this);
                this.drawTriggerPoints();
            }
        }

        refresh() {
            this.init();
        }

        onScroll() {
            switch (currentScrollDirection) {
                case "down":
                    if (
                        !this.hasPassedFromTop && // Has not yet entered from top
                        currentScrollPos >= this.triggerPointTop && // Has now passed top trigger point
                        !this.animationScheduled
                    ) {
                        this.hasPassedFromTop = true;
                        this.triggerPointEvent = "entered-from-top";
                        window.requestAnimationFrame(this.triggerPointHandler.bind(this));
                    }
                    if (
                        this.hasPassedFromBottom && // Had previously entered from bottom
                        currentScrollPos >= this.triggerPointBottom && // Has now passed bottom trigger point
                        !this.animationScheduled &&
                        !this.pointMode
                    ) {
                        this.hasPassedFromBottom = false;
                        this.triggerPointEvent = "left-towards-bottom";
                        window.requestAnimationFrame(this.triggerPointHandler.bind(this));
                    }
                    break;
                case "up":
                    if (
                        !this.hasPassedFromBottom && // Has not yet entered from bottom
                        currentScrollPos <= this.triggerPointBottom && // Has now passed bottom trigger point
                        !this.animationScheduled &&
                        !this.pointMode
                    ) {
                        this.hasPassedFromBottom = true;
                        this.triggerPointEvent = "entered-from-bottom";
                        window.requestAnimationFrame(this.triggerPointHandler.bind(this));
                    }
                    if (
                        this.hasPassedFromTop && // Had previous entered from top
                        currentScrollPos <= this.triggerPointTop && // Has now passed top trigger point
                        !this.animationScheduled
                    ) {
                        this.hasPassedFromTop = false;
                        this.triggerPointEvent = "left-towards-top";
                        window.requestAnimationFrame(this.triggerPointHandler.bind(this));
                    }
                    break;
            }
        }

        triggerPointHandler() {
            if (this.debug) console.log(this.triggerPointEvent);
            switch (this.triggerPointEvent) {
                case "entered-from-top":
                case "entered-from-bottom":
                    this.callback.enter(this.element, currentScrollDirection);
                    break;
                case "left-towards-top":
                case "left-towards-bottom":
                    this.callback.leave(this.element, currentScrollDirection);
                    break;
            }
            this.animationScheduled = false;
        }

        getOffset(_element) {
            var rect = _element.getBoundingClientRect();
            var win = _element.ownerDocument.defaultView;

            return rect.top + win.pageYOffset;
        }

        drawTriggerPoints() {
            var array = [this.triggerPointTop, this.triggerPointBottom];
            var el;

            document.querySelectorAll(".wypt-debug").forEach(function (_el) {
                _el.remove();
            });

            array.forEach(function (_val) {
                el = document.createElement("div");
                el.classList += "wypt-debug";
                el.innerText = `wypt-trigger-point: ${_val}px`;
                el.style.cssText = `
                    position: absolute;
                    top: ${_val}px;
                    right: 0;
                    background: yellow;
                `;
                document.body.appendChild(el);
            });
        }
    };

    WyPt.refreshAll = function () {
        instances.forEach((_instance) => _instance.refresh());
    };

    document.addEventListener("DOMContentLoaded", function () {
        new ResizeObserver(
            throttle(function () {
                WyPt.refreshAll();
            }, 100)
        ).observe(document.body);
    });

    window.addEventListener("resize", WyPt.refreshAll);

    window.addEventListener("scroll", function () {
        currentScrollPos = window.scrollY;
        currentScrollDirection = currentScrollPos > previousScrollPos ? "down" : "up";

        instances.forEach((_instance) => _instance.onScroll());

        previousScrollPos = currentScrollPos;
        previousScrollDirection = currentScrollDirection;
    });
}

export default WyPt;
